/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Vs_Who_Fc_TitleInputs */

const en_fc_vs_who_fc_title = /** @type {(inputs: Fc_Vs_Who_Fc_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose FilmCraft if you…`)
};

/**
* | output |
* | --- |
* | "Choose FilmCraft if you…" |
*
* @param {Fc_Vs_Who_Fc_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_vs_who_fc_title = /** @type {((inputs?: Fc_Vs_Who_Fc_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Vs_Who_Fc_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_vs_who_fc_title(inputs)
});
export { fc_vs_who_fc_title as "fc.vs.who.fc.title" }